import { Selector } from '@ngxs/store';
import { settingsList, View, WorkspaceManagementModel, WorkspaceManagementState } from './workspace-management.state';
import { Configuration, LayoutOption, WorkspaceManagementSettings } from 'fi-ui-common';


export class WorkspaceManagementSelectors {
  @Selector([WorkspaceManagementState])
  static isSidebarCollapsed(state: WorkspaceManagementModel): boolean {
    return state.isSidebarCollapsed;
  }

  @Selector([WorkspaceManagementState])
  static isAutosaveEnabled(state: WorkspaceManagementModel): boolean {
    return state.isAutosaveEnabled;
  }

  @Selector([WorkspaceManagementState])
  static getLayoutOptions(state: WorkspaceManagementModel): LayoutOption[] {
    return state.layoutOptions;
  }

  @Selector([WorkspaceManagementState])
  static getViews(state: WorkspaceManagementModel): View[] {
    return state.views;
  }

  @Selector([WorkspaceManagementState])
  static getSelectedLayout(state: WorkspaceManagementModel): Configuration | null {
    return state.selectedLayout;
  }

  @Selector([WorkspaceManagementState])
  static getSelectedViews(state: WorkspaceManagementModel): View[] {
    return state.views.filter(view => view.selected);
  }

  @Selector([WorkspaceManagementState])
  static getAllViews(state: WorkspaceManagementModel): View[] {
    return state.views;
  }

  @Selector([WorkspaceManagementState])
  static getAutosaveSettings(state: WorkspaceManagementModel) {
    return state.autosaveSettings;
  }

  @Selector([WorkspaceManagementState])
  static getSecondariesSettings(state: WorkspaceManagementModel) {
    return state.secondariesSettings;
  }

  @Selector([WorkspaceManagementState])
  static getSettingsList(state: WorkspaceManagementModel): WorkspaceManagementSettings[] {
    return settingsList.map(group => {
      if (group.groupId === 'autosaveSettings') {
        return {
          ...group,
          settings: group.settings.map(setting => ({
            ...setting,
            value: state.autosaveSettings[setting.field] ?? setting.value
          }))
        }
      } else {
        return group;
      }
    });
  }
}
